"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectEntityPropertiesToFetch = exports.entityPropertyHandlers = void 0;
var tslib_1 = require("tslib");
var types_1 = require("../types");
var text_1 = require("../text");
var common_1 = require("../common");
var asArray = function (value) { return (Array.isArray(value) ? value : [value]); };
var entityId = function (entityProperty) {
    return [entityProperty.entity, entityProperty.propertyKey, entityProperty.objectName].filter(Boolean).join('-');
};
var doesEntityPropertyMatch = function (condition, propertyValuesResponse) {
    var conditionType = Object.keys(condition)[0];
    var conditionFields = condition[conditionType];
    var id = entityId(conditionFields);
    var propertyValue = propertyValuesResponse[id];
    var expectedValue = conditionFields.value;
    var propValueArray;
    switch (conditionType) {
        case types_1.PropertyConditionType.EntityPropertyExists:
            return propertyValue != null;
        case types_1.PropertyConditionType.EntityPropertyEqualTo:
            return propertyValue === expectedValue;
        case types_1.PropertyConditionType.EntityPropertyContainsAny:
            propValueArray = asArray(propertyValue);
            return asArray(expectedValue).some(function (expected) { return propValueArray.includes(expected); });
        case types_1.PropertyConditionType.EntityPropertyContainsAll:
            propValueArray = asArray(propertyValue);
            return asArray(expectedValue).every(function (expected) { return propValueArray.includes(expected); });
        default:
            throw new Error(text_1.errors.unsupportedConditionType(conditionType));
    }
};
var clientConditionsPreCheck = function (clientDataConditionsLength, clientData) {
    if (!clientDataConditionsLength) {
        return common_1.Instruction.Continue;
    }
    if (!clientData) {
        return common_1.Instruction.NeedData;
    }
};
var entityPropertyAndHandler = function (propertyConditions, clientData) {
    var preCheck = clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) {
        return preCheck;
    }
    if (!propertyConditions.every(function (propCondition) {
        return doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) {
        return false;
    }
    return common_1.Instruction.Continue;
};
var entityPropertyOrHandler = function (propertyConditions, clientData) {
    var preCheck = clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) {
        return preCheck;
    }
    if (propertyConditions.some(function (propCondition) {
        return doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) {
        return true;
    }
    return common_1.Instruction.Continue;
};
var entityPropertyNotHandler = function (propertyConditions, clientData) {
    var preCheck = clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) {
        return preCheck;
    }
    if (propertyConditions.some(function (propCondition) { return !doesEntityPropertyMatch(propCondition, clientData.propertyValues); })) {
        return true;
    }
    return common_1.Instruction.Continue;
};
exports.entityPropertyHandlers = (_a = {},
    _a[common_1.AND_OPERATION] = entityPropertyAndHandler,
    _a[common_1.OR_OPERATION] = entityPropertyOrHandler,
    _a[common_1.NOT_OPERATION] = entityPropertyNotHandler,
    _a);
var buildPropertyValueRequest = function (entityProperty) {
    return tslib_1.__assign({ id: entityId(entityProperty), entity: entityProperty.entity, propertyKey: entityProperty.propertyKey }, (entityProperty.objectName && { objectName: entityProperty.objectName }));
};
exports.collectEntityPropertiesToFetch = function (conditionsInput) {
    var conditions = common_1.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var propertyRequests = [];
    if (Array.isArray(conditions)) {
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var propertyCondition = conditions_1[_i];
            var key = Object.keys(propertyCondition).find(common_1.isEntityPropertyCondition);
            if (key) {
                var entityProperty = propertyCondition[key];
                propertyRequests.push(buildPropertyValueRequest(entityProperty));
            }
        }
        return propertyRequests;
    }
    Object.entries(conditions)
        .filter(function (_a) {
        var key = _a[0], _ = _a[1];
        return common_1.isEntityPropertyCondition(key);
    })
        .forEach(function (_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push(buildPropertyValueRequest(condition));
    });
    Object.entries(conditions)
        .filter(function (_a) {
        var key = _a[0], _ = _a[1];
        return common_1.isOperation(key);
    })
        .forEach(function (_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push.apply(propertyRequests, exports.collectEntityPropertiesToFetch(condition));
    });
    return propertyRequests;
};
